import type AttachmentDataProvider from 'owa-service/lib/contract/AttachmentDataProvider';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import type FileProviderViewState from '../store/schema/FileProviderViewState';
import { FILE_PROVIDERS_LIST, FileProviderType } from './constants';

export function createFileProviderViewState(
    provider: AttachmentDataProvider
): FileProviderViewState {
    if (FILE_PROVIDERS_LIST.indexOf(provider.Type) < -1) {
        return null;
    }
    const providerType = <FileProviderType>provider.Type;
    try {
        // TODO VSO 30893 add file provider request is returning the scopes "Photos" and "Files", the GetAllAttachmentDataProviders request is only returning "Files"
        // remove the following filter on GDrive scopes when VSO 30893 is resolved
        const scopes =
            providerType === AttachmentDataProviderType.GDrive
                ? provider.Scopes.filter(provider => provider.DisplayName !== 'Photos')
                : provider.Scopes;
        return {
            name: provider.DisplayName,
            providerAccountIdentifier: provider.AssociatedDataProviderAccountId || '',
            isPrimaryProvider: !provider.IsThirdPartyProvider,
            type: providerType,
            allowFolderSharing: provider.AllowFolderSharing,
            model: provider,
            scopes: scopes || [],
            viewType: providerType,
            associatedWithPrimaryProvider: false,
            usesGroupsViewAtTopLevel: false,
        };
    } catch (error) {
        // In case of error, which can happen if the provider is unrecognized then return null
        return null;
    }
}

export default function createFileProvidersViewState(providers: AttachmentDataProvider[]) {
    return providers.map(createFileProviderViewState).filter(provider => provider !== null);
}
